import type { Icon } from "@phosphor-icons/react";
import { StatTile } from "@bednbody/ui/components/stat-tile";
import { ChartStatFlow } from "@/components/charts/chart-stat-flow";

interface StatCardProps {
  label: string;
  /** Prefer a number so the Bklit NumberFlow block animates. Strings (e.g.
   * "5/8" ratios) render statically. */
  value: string | number;
  icon: Icon;
  /** Prefix/suffix for numeric values (e.g. prefix="₱"). */
  prefix?: string;
  suffix?: string;
  hint?: string;
  tone?: "default" | "warning" | "success";
}

export function StatCard({
  label,
  value,
  icon,
  prefix,
  suffix,
  hint,
  tone = "default",
}: StatCardProps) {
  return (
    <StatTile layout="compact" label={label} detail={hint} icon={icon} tone={tone}>
      <div className="flex min-w-0 flex-col items-start">
        {/* Bklit stat block: animated NumberFlow value */}
        {typeof value === "number" ? (
          <ChartStatFlow
            value={value}
            prefix={prefix}
            suffix={suffix}
            valueClassName="text-2xl font-semibold leading-tight"
          />
        ) : (
          <>
            <span className="text-2xl font-semibold leading-tight tabular-nums text-foreground">
              {prefix}
              {value}
              {suffix}
            </span>
          </>
        )}
      </div>
    </StatTile>
  );
}
